// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"InputGroup_Wrapper__XWaS6","Label":"InputGroup_Label__ENE2H"};